import React, { Component } from 'react';
import UrlParse from 'url-parse';
import { Input, Row, Button, Table } from 'antd';
import { SearchOutlined} from '@ant-design/icons';
import Loading from '../../../components/loading';
import GeneralHelper from '../../../helpers/general';

export class EquipmentPage extends Component {
	state = {
		controller: '',
		type: '',
		status: '',
		location: '',
		equipment: ''
	};

	componentDidMount() {
		this.getEquipmentByLocation();
	}

	componentDidUpdate(prevProps) {
		const { meta: prevMeta } = prevProps.pageProps;
		const { meta } = this.props.pageProps;
		if (meta && meta !== prevMeta) {
			const alertOptions = {
				type: meta.code === 200 ? 'success' : 'error',
				...(meta.code === 40399 && { timeout: 0 })
			};
			this.props.alert.show(meta.message, alertOptions);
			this.props.resetMeta();
		}
	}

	componentWillUnmount() {
		this.props.resetPage();
	}

	getEquipments = async opts => {
		const { location } = this.props;
		const { query } = UrlParse(location.search, true);
		const { id } = query;

		this.props.getEquipments({ id });
	}

	getEquipmentByLocation = async opts => {
		const { location } = this.props;
		const { query } = UrlParse(location.search, true);
		const { id } = query;

		this.props.getEquipmentByLocation({ location_id: id });
	}

	getFilteredEquipments = async opts => {
		const { query } = UrlParse(this.props.location.search, true);
		const { equipment } = this.state;
		const {
			page,
			limit
		} = opts || {};

		this.props.getFilteredEquipments({
			page: page || query.page || 1,
			limit: limit || query.limit,
			search: {
				...(equipment && {name: equipment}),
				...(query.id && {location_id: query.id})
			}
		});
	}

	onFieldChange = (data) => {
		this.setState({ ...this.state, [data.name]: GeneralHelper.toNormalCase(data.value) });
	};

	render() {
		const { loading, equipments, filteredEquipments, search } = this.props.pageProps;
		const {  equipment } = this.state;

		const columns = [
			{
				title: 'Equipment',
				dataIndex: 'name',
				key: 'name',
				render: (name) => GeneralHelper.truncateString(name, 75)
			}
		];

		return (
			<>
				{ loading ?
					<Loading /> :
					<>
						<Row
							className={'search-input-container'}
							style={{
								marginBottom: '1rem',
								paddingTop: 10
							}}
						>
							<Input
								placeholder="Search Equipment"
								value={equipment}
								onChange={(e) => {
									const data = {
										name: 'equipment',
										value: e.target.value
									};
									this.onFieldChange(data);
								}}
								style={{ maxWidth: 230, marginRight: 10, marginTop: 5 }}
								onPressEnter={this.getFilteredEquipments}
								allowClear
							/>
							<Button
								icon={<SearchOutlined />}
								style={{ background: '#003366', color: '#ffffff', marginTop: 5 }}
								onClick={this.getFilteredEquipments}
							>
								Search
							</Button>

						</Row>
						<Table
							rowKey={equipment => equipment._id}
							columns={columns}
							dataSource={search ? filteredEquipments : equipments }
							style={{ width: '100%', marginTop: 15 }}
							scroll={{ x: 400 }}
						/>
					</>

				}
			</>
 		);
 	}
}
export default EquipmentPage;
